import { render, staticRenderFns } from "./CurrentScoreSetting.vue?vue&type=template&id=45747742&scoped=true"
import script from "./CurrentScoreSetting.vue?vue&type=script&lang=js"
export * from "./CurrentScoreSetting.vue?vue&type=script&lang=js"
import style0 from "./CurrentScoreSetting.vue?vue&type=style&index=0&id=45747742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45747742",
  null
  
)

export default component.exports